import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { GeneralService } from './general.service';
import { catchError, Observable, of, take } from 'rxjs';
import { environment } from '../../../environments/environment';
import {
  ClosingData,
  ColoniesResponse,
  InitialGPS,
  LocationDataResponse,
  WorkFlowListData,
  WorkFlowLocation,
} from '../models/hybrid-model/gps.model';
import { FieldItem } from '../models/hybrid-model/filed-input-model';

@Injectable({
  providedIn: 'root',
})
export class HybridPageService {
  public URL_API = environment.apiURLNew;

  constructor(
    private http: HttpClient,
    private generalService: GeneralService,
  ) {}

  // 1* Obtener datos iniciales de GPS
  public getInitialGPSData(quotationId: number | string): Observable<InitialGPS | null> {
    return this.http
      .get<InitialGPS>(`${environment.apiURLNew}/api/GPS/GetInitialGPSData/${quotationId}`)
      .pipe(
        take(1),
        catchError(() => {
          return of(null);
        }),
      );
  }

  public getGeoConfig(workFlowTypeId: number | string): Observable<number | null> {
    return this.http
      .get<number>(`${environment.apiURLNew}/api/GPS/GetGeoConfig/${workFlowTypeId}`)
      .pipe(
        take(1),
        catchError(() => {
          return of(null);
        }),
      );
  }

  //  GPS
  //workflowTypeId (Falta servicio de consulta)
  // 5 Regresa coleccion de campos dependiendo de workflowId Campos de cierre para instalacion
  public workFlowEditClosingFieldList(
    body: WorkFlowLocation,
  ): Observable<{ data: FieldItem[]; errors: any[]; hasErrors: boolean } | null> {
    return this.http
      .post<{
        data: FieldItem[];
        errors: any[];
        hasErrors: boolean;
      }>(`${environment.apiURLNew}/api/GPS/WorkFlowEditClosingFieldList`, body)
      .pipe(
        take(1),
        catchError(() => {
          return of(null);
        }),
      );
  }

  // trae el array de los campos hijos que dependen (de los campos WorkFlowEditClosingFieldList)
  public editClosingFieldCatalogList(body: {
    closingFieldId: number;
    componentCatalogId: number;
    postalCode: string;
    quotationId: number;
    selectedValue: number;
    workflowId: number;
    workflowTypeId: number;
  }): Observable<any> {
    return this.http
      .post<any>(`${environment.apiURLNew}/api/GPS/EditClosingFieldCatalogList`, body)
      .pipe(
        take(1),
        catchError(() => {
          return of(null);
        }),
      );
  }

  public locationEditClosingFieldList(body: WorkFlowLocation): Observable<any> {
    return this.http
      .post<any>(`${environment.apiURLNew}/api/GPS/LocationEditClosingFieldList`, body)
      .pipe(
        take(1),
        catchError(() => {
          return of(null);
        }),
      );
  }

  // 3* Falta el de codigo postal
  public postalCodeList(body: WorkFlowLocation): Observable<ColoniesResponse | null> {
    return this.http
      .post<ColoniesResponse>(`${environment.apiURLNew}/api/GPS/PostalCodeList`, body)
      .pipe(
        take(1),
        catchError(() => {
          return of(null);
        }),
      );
  }

  // 3 Este servicio revcisa si ya existen datos del gps (Con datos de cp)
  // optiene los gps crados anterior mente
  public locationDetailKey(body: WorkFlowLocation): Observable<any> {
    return this.http.post<any>(`${environment.apiURLNew}/api/GPS/LocationDetailKey`, body).pipe(
      take(1),
      catchError(() => {
        return of(null);
      }),
    );
  }

  // 4 Selecciona el workflow (hasta arriba )4
  public getWorkFlowList(body: WorkFlowLocation): Observable<WorkFlowListData | null> {
    return this.http
      .post<WorkFlowListData>(`${environment.apiURLNew}/api/GPS/WorkFlowList`, body)
      .pipe(
        take(1),
        catchError(() => {
          return of(null);
        }),
      );
  }

  // obtiene los detos de los campos (inputs) si regresa nada se ejecuta LocationEditClosingFieldList
  public savedData(body: WorkFlowLocation): Observable<any | null> {
    return this.http.post<any>(`${environment.apiURLNew}/api/GPS/SavedData`, body).pipe(
      take(1),
      catchError(() => {
        return of(null);
      }),
    );
  }

  // 2* Crear Geo falta id de cotizacion nombnre de cliente y codigo postal con direccion
  // en caso de llafa mostar modal con errores
  public crearGeo(body: {
    apartmentNumber: string;
    areaNumber: string;
    client: string;
    postalCode: string;
    quotationId: number;
    streetName: string;
    streetNumber: string;
    telephone: string;
  }): Observable<any> {
    return this.http.post<any>(`${environment.apiURLNew}/api/GPS/CrearGeo`, body).pipe(
      take(1),
      catchError(() => {
        return of(null);
      }),
    );
  }

  public createWorkflowProject(body: ClosingData): Observable<LocationDataResponse | null> {
    return this.http
      .post<LocationDataResponse>(`${environment.apiURLNew}/api/GPS/CreateWorkflowProject`, body)
      .pipe(
        take(1),
        catchError(() => {
          return of(null);
        }),
      );
  }
}
